import ListItem, { Props as ListItemProps, ListSectionHeader } from '@components/2-molecules/ListItem';
import styled, { css } from '@emotion/native';
import React, { FC } from 'react';


import { SectionList as RNSectionList, SectionListRenderItem, View } from 'react-native';
import _ from 'underscore';

import { Text } from "@components/1-atoms";

import * as utils from '@lib/utils';

import { ChartAccountDataProps } from '@/interfaces/chart.interface';
import DefaultCheckedIcon from '@assets/icons/checked';



type SectionType = { title: string; data: ReadonlyArray<ChartAccountDataProps> };

// Create a typed SectionList component
const SectionList = styled(RNSectionList<ChartAccountDataProps, SectionType>)``;

type Props = Omit<ListItemProps, 'children' | 'onPress' | 'data'> & {
    data: ChartAccountDataProps[];
    defaultValue: ChartAccountDataProps | null;
    onChange?: (value: ChartAccountDataProps) => void;
    onPress?: (selected: ChartAccountDataProps) => void;
};


const ListChartAccount: FC<Props> = ({ defaultValue, data, onPress, onChange, ...props }) => {

    const [value, setValue] = React.useState<ChartAccountDataProps | null>(defaultValue);
    React.useEffect(() => setValue(defaultValue), [defaultValue]);

    React.useEffect(() => {
        if (defaultValue) onChange?.(defaultValue);
    }, [value]);

    const _onPress = (item: ChartAccountDataProps) => {
        onPress?.(item);
    };

    // Create a new variable for the sectioned data to avoid reassigning the 'data' prop.
    const sectionedData = _.chain(data)
        .groupBy(_.property(['institutionName']))
        .map((chartAccounts: any, key: string) => ({
            title: key,
            data: chartAccounts,
        }))
        // unwraps the Underscore object to return the final result.
        .value();

    const _renderItem: SectionListRenderItem<ChartAccountDataProps, SectionType> = ({ item }) => {

        return (
            <View>
                <ListItem
                    onPress={() => { _onPress(item) }}
                    right={(utils.deepEqual(value, item) && <DefaultCheckedIcon />)}
                    sub={<Text small color={"#808080"}>{item.description}</Text>}
                    {...props}
                >
                    <Text>{item.name}</Text>
                </ListItem>
            </View>
        );
    };



    return (
        <View>

            {/* The `AppTemplate` provides a main ScrollView that wraps all the page content. */}
            {/* This ScrollView's job is to allow the entire page content to scroll if its content */}
            {/* is taller than the screen. */}

            {/* This SectionList is itself a scrollable view. */}

            {/* The SectionList tries to render with an infinite height, which causes the outer ScrollView */}
            {/* to think its content is infinitely tall. This breaks the layout, often causing the list to expand */}
            {/* and push everything below it off-screen, which is exactly the behavior you were seeing. */}

            {/* WARNINGS ⚠️ : The list has a infinite height when the following styles are removed.  */}
            {/*               The view contains the list inside its immediate container.*/}
            <View style={css(`width: 100%; height: auto; `)}>
                <SectionList
                    scrollEnabled={false}
                    sections={sectionedData as SectionType[]}
                    keyExtractor={(item) => `${item.id}`}
                    renderItem={_renderItem}
                    renderSectionHeader={({ section: { title } }) => <ListSectionHeader children={title} />}
                />
            </View>
        </View>
    );


};

export default ListChartAccount;